export default {
  提交成功: '提交成功',
  数据保存中: '数据保存中',
  是必填项: '是必填项',
  添加客户关键联系人: '添加客户关键联系人',
  编辑客户关键联系人: '编辑客户关键联系人',
  删除该联系人: '删除该联系人',
  请确认是否删除: '请确认是否删除',
  这条客户关键联系人: '这条客户关键联系人',
  获取数据失败: '获取数据失败',
  基本特征: '基本特征',
  修改: '修改',
  使用情况: '使用情况',
  查找数据: '查找数据',
  数据日期: '数据日期',
  人均使用时长情况: '人均使用时长情况',
  人均活跃情况: '人均活跃情况',
  CCM渗透情况: 'CCM渗透情况',
  审批渗透情况: '审批渗透情况',
  日历渗透情况: '日历渗透情况',
  IM渗透情况: 'IM渗透情况',
  打卡渗透情况: '打卡渗透情况',
  音视频会议渗透情况: '音视频会议渗透情况',
  编辑动态记录: '编辑动态记录',
  外部: '外部',
  我方参会人: '我方参会人',
  客户参会人: '客户参会人',
  妙记链接: '妙记链接',
  查看: '查看',
  跟进详情: '跟进详情',
  取消: '取消',
  评论: '评论',
  暂无沟通记录: '暂无沟通记录',
  回复: '回复',
  添加跟进: '添加跟进',
  编辑跟进: '编辑跟进',
  请输入评论内容: '请输入评论内容',
  展开更多: '展开更多',
  折叠收起: '折叠收起',
  收起: '收起',
  展开: '展开',
  暂无此售后服务查看权限: '暂无此售后服务查看权限',
  客户特征: '客户特征',
  客户关键联系人: '客户关键联系人',
  '客户伙伴数据(天维度)': '客户伙伴数据(天维度)',
  商机: '商机',
  资料沉淀: '资料沉淀',
  姓名: '姓名',
  对接产品线: '对接产品线',
  对接人角色: '对接人角色',
  对接人职位: '对接人职位',
  所在部门: '所在部门',
  对接人态度: '对接人态度',
  联系方式: '联系方式',
  补充信息: '补充信息',
  编辑客户特征: '编辑客户特征',
  跟进时间: '跟进时间',
  跟进类型: '跟进类型',
  转移负责人: '转移负责人'
};
